import {ErrorModel} from '../app.model';
import {ACTION_TYPES} from '../app.types';
import {TargetAction} from './target.service';
import {createFeatureSelector, createSelector} from '@ngrx/store';

export interface TargetContainerState {
  error?: ErrorModel,
  errors: ErrorModel[],
}

export const INITIAL_STATE: TargetContainerState = {
  error: undefined,
  errors: []
};

// TODO refactor the way we approach error handling
export function targetContainer(state: TargetContainerState = INITIAL_STATE,
                                action: TargetAction = {type: '?'}) {

  switch (action.type) {
    case ACTION_TYPES.TARGET_ERROR:
      return {...state, error: action.error};
    case ACTION_TYPES.TARGETS_SHARED_FOR_SEGMENT:
      return {...state, errors: action.errors};
    default:
      return {...state};
  }
}

export const targetsFeatureSelector = createFeatureSelector<{ error: ErrorModel }>('targetContainer');
export const selectTargetError = createSelector(
  targetsFeatureSelector,
  (state) => state.error
);
